<template>
  <transition name="modal">
    <div class="modal-mask" v-cloak>
      <div class="container">
        <div class="modal-wrapper" v-cloak>
          <div
            class="modal-dialog modal-dialog-scrollable"
            role="document"
            v-cloak
          >
            <div class="modal-content modal-dialog-centered">
              <div class="modal-header">
                <h5
                  class="modal-title"
                  id="modalTitle"
                  style="text-align:center"
                >
                  {{ title }}
                </h5>
                <button
                  type="button"
                  class="close"
                  @click="closeModal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div v-html="content"></div>
                <div class="text-center">
                  <button
                    type="button"
                    @click="readInformation"
                    class="btn btn-primary"
                  >
                    {{ cta }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "information-modal",
  props: {
    title: {
      type: String
    },
    content: {
      type: String
    },
    cta: {
      type: String
    }
  },
  methods: {
    readInformation() {
      this.$emit("readInformation");
      this.$store.dispatch("getUserTasks").then(() => {
        this.closeModal();
      });
    },
    closeModal() {
      this.$emit("closeInformationModal");
    }
  }
};
</script>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
}
.modal-mask .container {
  height: 100%;
  position: relative;
  display: table;
}

.modal-mask .container .close {
  position: absolute;
  top: 22px;
  right: 30px;
  padding: 0;
  opacity: 1;
  font-size: 30px;
  font-weight: lighter;
}

.modal-mask .modal-title {
  word-break: break-word;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-header,
.modal-footer {
  border: 0;
}
.modal-header {
  padding-top: 50px;
  padding-bottom: 0;
}
.modal-body {
  padding-top: 0;
  max-height: calc(100vh - 212px);
  overflow-y: auto;
  margin: 10px;
}

.modal-body >>> img {
  max-width: 100% !important;
  height: auto !important;
}

.modal-body::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

.modal-body::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>
